























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {sleep} from 'simpli-web-sdk'

@Component
export default class FilterToggle extends Vue {
  @Prop({type: Boolean, default: false}) startOpen!: boolean

  open: boolean | null = this.startOpen // open is null when it is in transition mode

  async toggleOpen(open: boolean) {
    if (open) {
      this.open = null
      await sleep(400)
      this.open = true
    } else {
      this.open = null
      await sleep(400)
      this.open = false
    }
  }
}
